import { Check, NotebookPen } from 'lucide-react';
import type { MouseEvent, ReactNode } from 'react';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CrmEventDTO } from '../../../server/dto/crm-event-dto.ts';
import type { CrmNoteDTO } from '../../../server/dto/crm-note-dto.ts';

type Props = {
    event: CrmEventDTO & { notes: CrmNoteDTO[] };
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export function EventLogButton({ event, onClick }: Props): ReactNode {
    const { t } = useLocale('events');

    return (
        <div className="w-full flex justify-end">
            <Button
                disabled={!event.customerId}
                variant={event.notes.length > 0 ? 'ghost' : 'secondary'}
                icon={event.notes.length > 0 ? Check : NotebookPen}
                onClick={onClick}
                className={event.notes.length > 0 ? 'text-green-600' : undefined}
            >
                {event.notes.length > 0 ? t('card_log_button_logged') : t('card_log_button')}
            </Button>
        </div>
    );
}
